<!-- components/Hero.vue -->
<template>
  <section class="hero" id="start">
    <DemoModal
      :dMessages="dMessages"
      :isModalOpen="showModal"
      @eventOnCloseModal="onCloseModal"
    />
    <div class="hero-content">
      <transition name="slide-up" appear>
        <h1>
          <span class="typing">{{ typedText }}</span>
        </h1>
      </transition>
      <transition name="fade" appear>
        <p>{{ lMessages["subtitle"] }}</p>
      </transition>
      <transition name="slide-up" appear>
        <div class="cta-buttons">
          <router-link :to="{ name: 'register' }">
            <button class="trial-btn">
              {{ lMessages["trial"] }}
            </button>
          </router-link>
          <button @click="showModal = true" class="demo-btn">
            {{ lMessages["demo"] }}
          </button>
        </div>
      </transition>
    </div>
    <div class="hero-visual">
      <transition name="pop" appear>
        <img
          src="@/assets/images/analyst.png"
          alt="Financial Dashboard"
          class="main-image"
        />
      </transition>
      <transition name="slide-right" appear>
        <div class="card-overlay card-1">
          <img :src="symbol" height="26" alt="" style="padding: 0 1rem 0 0" />{{
            lMessages["highlight1"]
          }}
        </div>
      </transition>
      <transition name="slide-right" appear>
        <div class="card-overlay card-2">
          <img
            :src="markets"
            height="26"
            alt=""
            style="padding: 0 1rem 0 0"
          />{{ lMessages["highlight2"] }}
        </div>
      </transition>
      <transition name="slide-left" appear>
        <div class="card-overlay card-3">
          <img
            :src="strategy"
            height="26"
            alt=""
            style="padding: 0 1rem 0 0"
          />{{ lMessages["highlight3"] }}
        </div>
      </transition>
      <transition name="slide-left" appear>
        <div class="card-overlay card-4">
          <img
            :src="multiAsset"
            height="26"
            alt=""
            style="padding: 0 1rem 0 0"
          />{{ lMessages["highlight4"] }}
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
import DemoModal from "@/components/landing/DemoModal.vue";

export default {
  name: "Hero",
  components: {
    DemoModal
  },
  props: {
    dMessages: { required: true, default: () => [] },
    lMessages: { required: true, default: () => [] }
  },
  data() {
    return {
      fullText: "",
      markets: require("@/assets/images/globe_blue.svg"),
      multiAsset: require("@/assets/images/strategy_blue.png"),
      strategy: require("@/assets/images/overview_blue.png"),
      symbol: require("@/assets/images/symbol_white.png"),
      typedText: "",
      typingSpeed: 100,
      showHeadings: false,
      showModal: false
    };
  },
  created() {
    this.fullText = this.lMessages["title"];
  },
  mounted() {
    // Force animation loading when mounting the component
    this.$nextTick(() => {
      this.$forceUpdate();
    });
    setTimeout(() => {
      this.animateText();
      setTimeout(() => {
        this.showHeadings = true;
      }, 500);
    }, 1000);
  },
  methods: {
    onCloseModal(val) {
      this.showModal = val;
    },
    animateText() {
      let index = 0;
      const interval = setInterval(() => {
        if (index < this.fullText.length) {
          this.typedText += this.fullText[index];
          index++;
        } else {
          clearInterval(interval);
        }
      }, this.typingSpeed);
    }
  }
};
</script>

<style scoped>
.hero {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5% 0 5%;
  min-height: 100vh;
  background: var(--darkbackgroundFixed);
  color: white;
  overflow: hidden;
}

.hero-content {
  max-width: 40%;
  padding-right: 2rem;
}

h1 {
  font-size: 3.5rem;
  color: white;
  margin-bottom: 1rem;
  line-height: 1.2;
}

p {
  font-size: 1.3rem;
  color: var(--textInactiveFixed);
  margin-bottom: 2rem;
}

.cta-buttons {
  display: flex;
  gap: 1rem;
}

.trial-btn,
.demo-btn {
  padding: 1rem 2rem;
  border: none;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: 500;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
}

.trial-btn {
  background: var(--logo-blue);
  color: var(--white);
}

.demo-btn {
  background: var(--graylightbackgroundFixed);
  color: var(--white);
}

.trial-btn:hover,
.demo-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.hero-visual {
  position: relative;
  max-width: 60%;
}

.main-image {
  width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.card-overlay {
  position: absolute;
  padding: 1rem 2rem 1rem 1.3rem;
  color: rgba(255, 255, 255, 0.95);
  background: var(--blacker-gray-fixed);
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: bold;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.7);
}

.card-1 {
  top: 30%;
  left: -1%;
}
.card-2 {
  bottom: -2.3%;
  right: -2.5%;
}
.card-3 {
  bottom: 15%;
  left: 13%;
}
.card-4 {
  top: -3%;
  right: 23%;
}
.card-1:hover,
.card-2:hover,
.card-3:hover,
.card-4:hover {
  transform: scale(1.02);
}

/* Animations */
.slide-up-enter-active {
  transition: all 0.8s ease;
}
.slide-up-enter {
  opacity: 0;
  transform: translateY(50px);
}

.fade-enter-active {
  transition: all 0.8s ease 0.2s;
}
.fade-enter {
  opacity: 0;
}

.pop-enter-active {
  transition: all 1s ease 0.4s;
}
.pop-enter {
  opacity: 0;
  transform: scale(0.8);
}

.slide-right-enter-active {
  transition: all 1s ease 0.6s;
}
.slide-right-enter {
  opacity: 0;
  transform: translateX(-100px);
}

.slide-left-enter-active {
  transition: all 1s ease 0.8s;
}
.slide-left-enter {
  opacity: 0;
  transform: translateX(100px);
}

/* Styles for the writing effect */
.typing {
  border-right: 2px solid var(--white);
  padding-right: 2px;
  animation: blink 0.8s infinite;
}
/* Cursor blinking */
@keyframes blink {
  50% {
    border-color: transparent;
  }
}
</style>
